module.exports = __webpack_public_path__ + "static/media/70.882754c9.jpg";